import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";
import PersonFactory from "../../Entity/Factories/PersonFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";

export default function* personUpdate(action: ActionInterface): any {
  switch (action.type) {
    case Constants.PAGE_CONTACT_PERSON_UPDATE_START:
      try {
        yield put({
          type: Constants.PAGE_CONTACT_PERSON_UPDATE_CLEAR
        });

        yield put({
          type: Constants.PAGE_CONTACT_PERSON_UPDATE_REQUEST
        });

        const companiesForPerson: any[] = [];

        if (action.payload?.person?.company?.id) {
          companiesForPerson.push({
            id: action.payload?.person?.company?.id,
            role: action.payload?.person?.companyRole || ""
          });
        }
        
        // If we have additional fields, we have to push those into the array too.
        action.payload?.person?.additionalFields?.forEach(field => {
          if (!field) {
            return;
          }

          if (!field?.selectedCompany) {
            return;
          }

          companiesForPerson.push({
            id: field?.selectedCompany?.id,
            role: field?.role || ""
          });
        });

        const res = yield call(Http.put, `contact/${action.payload?.id}`, {...action.payload?.person, companyIds: [...companiesForPerson]});
        const person: PersonInterface = PersonFactory.create(res.data.data);

        yield put({
          type: Constants.PAGE_CONTACT_PERSON_UPDATE_SUCCESS,
          payload: {
            person: person,
            previousCompanyId: action.payload?.previousCompanyId
          }
        });

        if (person?.isUser() || person?.isAdmin()) {
          yield put({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: Translator.trans("snackbar-message-user-updated-successfully"),
              type: "success"
            }
          });
        } else {
          if (!action.payload?.hideSnackbar) {
            yield put({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: Translator.trans("snackbar-message-person-updated-successfully"),
                type: "success"
              }
            });
          }
        }

        yield put({
          type: Constants.PAGE_CONTACTS_SWITCH_TAB,
          payload: {
            index: 0
          }
        });

        if (action.hasOwnProperty("onSuccess") === true) {
          action.onSuccess.call(this, person);
        }
      } catch (err) {

        yield ErrorHandlerSequence(err, action);

        yield put({
          type: Constants.PAGE_CONTACT_PERSON_UPDATE_FAILURE,
          payload: {
            err: err
          }
        });
      }
      break;

    case Constants.PAGE_SETTINGS_USER_PROFILE_UPDATE_START:
      try {
        yield put({
          type: Constants.PAGE_SETTINGS_USER_PROFILE_UPDATE_REQUEST
        });

        const companiesForPerson: any[] = [];

        if (action.payload?.person?.company?.id) {
          companiesForPerson.push({
            id: action.payload?.person?.company?.id,
            role: action.payload?.person?.companyRole || ""
          });
        }

        const res = yield call(Http.put, `contact/${action.payload?.id}`, {...action.payload?.person, companyIds: [...companiesForPerson]});
        const person: PersonInterface = PersonFactory.create(res.data.data);

        yield put({
          type: Constants.PAGE_SETTINGS_USER_PROFILE_UPDATE_SUCCESS,
          payload: {
            person: person
          }
        });

        if (person?.isUser() || person?.isAdmin()) {
          yield put({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: Translator.trans("snackbar-message-user-updated-successfully"),
              type: "success"
            }
          });
        } else {
          yield put({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: Translator.trans("snackbar-message-person-updated-successfully"),
              type: "success"
            }
          });
        }


        if (action.hasOwnProperty("onSuccess") === true) {
          action.onSuccess.call(this, person);
        }
      } catch (err) {

        yield ErrorHandlerSequence(err, action);

        yield put({
          type: Constants.PAGE_SETTINGS_USER_PROFILE_UPDATE_FAILURE,
          payload: {
            err: err
          }
        });
      }
      break;

    case Constants.GLOBAL_COMPANY_ADD_PERSON:
      try {
        const res = yield call(Http.put, `contact/${action.payload?.person.id}`, {
          companyId: action.payload?.id,
          companyIds: [...action?.payload?.companyIds]
        });

        const person: PersonInterface = PersonFactory.create(res.data.data);

        yield put({
          type: Constants.PAGE_CONTACT_PERSON_UPDATE_SUCCESS,
          payload: {
            person: person,
            previousCompanyId: action.payload?.person.companyId
          }
        });

        yield put({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: Translator.trans("snackbar-person-added-to-company-successfully")
          }
        });
        
        if (typeof action.onSuccess !== "undefined") {
          action.onSuccess.call(this, person);
        }
      } catch (err) {
        yield ErrorHandlerSequence(err, action);
      }
    break;

    case Constants.GLOBAL_COMPANY_UNLINK_PERSON_START:
      try {
        yield put({
          type: Constants.GLOBAL_COMPANY_UNLINK_PERSON_REQUEST
        });

        const res = yield call(Http.put, `contact/${action.payload?.person.id}`,{
          companyIds: [...action?.payload?.companyIds],
        });
        const person: PersonInterface = PersonFactory.create(res.data.data);

        yield put({
          type: Constants.GLOBAL_COMPANY_UNLINK_PERSON_SUCCESS,
          payload: {
            companyId: action.payload?.companyId,
            person: person
          }
        });

        yield put({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: Translator.trans("snackbar-person-unlinked-from-company-successfully"),
            type: "success"
          }
        });

        
      } catch (err) {
        yield ErrorHandlerSequence(err, action);

        yield put({
          type: Constants.GLOBAL_COMPANY_UNLINK_PERSON_FAILURE
        });

      }
    break;

    default:
      throw new Error("Unknown type");
  }
}

export function* watchPersonUpdate() {
  yield takeEvery(Constants.PAGE_SETTINGS_USER_PROFILE_UPDATE_START, personUpdate);
  yield takeEvery(Constants.PAGE_CONTACT_PERSON_UPDATE_START, personUpdate);
  yield takeEvery(Constants.GLOBAL_COMPANY_ADD_PERSON, personUpdate);
  yield takeEvery(Constants.GLOBAL_COMPANY_UNLINK_PERSON_START, personUpdate);
}
